'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconUploadBottom = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M0 19.59a4.039 4.039 0 0 0 4.035 4.035h15.93A4.039 4.039 0 0 0 24 19.59v-1.874a1.225 1.225 0 1 0-2.449 0v1.874a1.588 1.588 0 0 1-1.586 1.586H4.035a1.588 1.588 0 0 1-1.586-1.586v-1.874a1.225 1.225 0 1 0-2.449 0z' }),
    _react2.default.createElement('path', { d: 'M12 19.322a1.959 1.959 0 0 0 1.959-1.959V8.2a.25.25 0 0 1 .25-.25H16.9a.979.979 0 0 0 .739-1.622L12.739.7a1.011 1.011 0 0 0-1.478 0l-4.9 5.633A.979.979 0 0 0 7.1 7.951h2.691a.25.25 0 0 1 .25.25v9.162A1.959 1.959 0 0 0 12 19.322z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M3.869 23.501A3.372 3.372 0 0 1 .5 20.132v-1.913a.5.5 0 0 1 1 0v1.913a2.372 2.372 0 0 0 2.369 2.369h16.262a2.373 2.373 0 0 0 2.369-2.369v-1.913a.5.5 0 0 1 1 0v1.913a3.374 3.374 0 0 1-3.369 3.369H3.869z' }),
    _react2.default.createElement('path', { d: 'M12 18.608a.5.5 0 0 1-.5-.5v-15.9L5.354 8.354a.496.496 0 0 1-.708 0 .501.501 0 0 1 0-.707l7-7A.495.495 0 0 1 12 .501a.5.5 0 0 1 .354.146l7 7a.5.5 0 1 1-.708.708L12.5 2.208v15.901a.5.5 0 0 1-.5.499z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12.001 16.5a.75.75 0 0 1-.75-.75V5.561l-3.22 3.22a.746.746 0 0 1-1.06-.001c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53l4.499-4.5a.74.74 0 0 1 .245-.163l.025-.009a.743.743 0 0 1 .522 0l.02.007c.097.04.179.095.25.166l4.499 4.499c.142.141.22.33.22.53s-.078.389-.22.53a.749.749 0 0 1-1.06 0l-3.22-3.22v10.19a.75.75 0 0 1-.75.75z' }),
    _react2.default.createElement('path', { d: 'M3.751 21a3.754 3.754 0 0 1-3.75-3.75v-1.5a.75.75 0 0 1 1.5 0v1.5a2.252 2.252 0 0 0 2.25 2.25h16.5a2.252 2.252 0 0 0 2.25-2.25v-1.5a.75.75 0 0 1 1.5 0v1.5a3.754 3.754 0 0 1-3.75 3.75h-16.5z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconUploadBottom.displayName = 'IconUploadBottom';
exports.default = IconUploadBottom;